import * as moment from 'moment';

const DT_TEMPLATE = /(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2})\s*(.*)/;
const ISO_8601 = moment.ISO_8601;
const ISO_FMT = 'YYYY-MM-DDTHH:mm:ssZ';

function _normalized(str: string, tmplt: RegExp = DT_TEMPLATE): string {
	const parts: string[] | null = str.match(tmplt);
	if (parts == null) {
		return '';
	}
	let tz: string = parts[3];
	if (tz !== '') {
		const tzsign: string = tz[0];
		tz = tz.slice(1);
		if (tz.length === 2) {
			tz = tzsign + tz + ':00';
		} else if (tz.length === 4) {
			tz = tzsign + tz.slice(0, 2) + ':' + tz.slice(2);
		} else {
			tz = tzsign + tz;
		}
	} else {
		tz = 'Z';
	}
	return parts.slice(1, 3).join('T') + tz;
}

/**
 * Parse a date-time string and return a Date.
 * @param str
 * @param tmplt
 */
export const fromString = (str: string, tmplt: RegExp = DT_TEMPLATE): Date => {
	return moment(_normalized(str, tmplt), ISO_8601).toDate();
};

/**
 * Convert a date to a JSON-compatible string
 * @param dt
 */
export const dateToJSON = (dt: Date): string => {
	return moment(dt) //
		.utc()
		.format(ISO_FMT);
};

/**
 * Convert a string representing a date to a localized format of that date
 * @param str
 * @param format
 * @param tmplt
 */
// tslint:disable-next-line:max-line-length
export const formattedFromString = (str: string, format: string = 'lll', tmplt: RegExp = DT_TEMPLATE): string => {
	return moment(_normalized(str, tmplt), ISO_8601).format(format);
};

/**
 * Convert a string reprenting a date to a Moment object
 * @param str
 * @param tmplt
 */
export const asMoment = (str: string, tmplt: RegExp = DT_TEMPLATE): moment.Moment => {
	return moment(_normalized(str, tmplt), ISO_8601);
};
